module.exports = "<a href class=\"am4-button am4-button--primary-alt am4-dashboard__export\" ng-click=\"dash.exportMachines()\" data-cy=\"resultsExportCSV\">\n  {{'EXPORT_TO_CSV' | translate}}\n</a>\n<a href class=\"am4-button am4-button--primary am4-dashboard__scroll-to-top fade\" ng-show=\"infiniteScrollFooterCtrl.scrolledBeyondTop\" scroll-to=\"am4-dashboard-scroll-top-target\" title=\"{{'SCROLL_TO_TOP' | translate}}\" data-cy=\"resultsTop\">\n    <i class=\"fa fa-angle-up\"></i>Top\n</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/dashboard/dashboardFooter.html
// module id = 395
// module chunks = 14